export const dataHooks = {
  menuArrow: 'input-menu-arrow',
  status: 'input-status',
  statusIndicatorTooltip: 'status-indicator-tooltip',
  suffixes: 'input-suffixes',
  tooltip: 'input-suffix-tooltip',
};

export const SIZES = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};
